<!-- Courses -->
<section>

    <!-- Page Title -->
    <div class="title">
        <h1>Courses</h1>
        <button *ngIf="courses.length !== 0" type="button" class="btn waves-dark" [routerLink]="'/enroll'">Add Course</button>
    </div>

    <hr class="line" *ngIf="courses.length !== 0">

    <!-- No Courses -->
    <div *ngIf="courses.length === 0" class="no-courses">
        <h2 class="no-course-title">You're not enrolled in any courses. Click here to get started!</h2>
        <mdb-icon fas icon="long-arrow-alt-down" class="arrow"></mdb-icon>
    </div>

    <!-- List of Courses -->
    <div class="courses-list">

        <!-- Individual Courses -->
        <div *ngFor="let course of courses; let i = index" class="content-box course" (click)="onCourse(course)">
            <!-- FHE was renamed to HPE but we use FHE as the courseID in the backend, so need to manually display it instead of courseID -->
            <h1 *ngIf="course.courseID === 'Fair Housing Education'">Housing Provider Education</h1>
            <h1 *ngIf="course.courseID !== 'Fair Housing Education'">{{course.courseID}}</h1>
            <circle-progress [percent]="progressList[i]" [radius]="70" [outerStrokeWidth]="15" [innerStrokeWidth]="8" [outerStrokeColor]="colors[i].outerColor" [innerStrokeColor]="colors[i].innerColor" [animation]="true" [animationDuration]="300"></circle-progress>
        </div>
    </div>
</section>

<!-- Enroll Button -->
<section *ngIf="courses.length === 0">
    <div class="container text-center">
        <button type="button" class="btn waves-dark w-50" [routerLink]="'/enroll'">Add Course</button>
    </div>
</section>
